import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { usuario, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          Multicentro 360º
        </Link>
        
        {usuario ? (
          <div className="navbar-menu">
            <Link to="/dashboard" className="navbar-link">Dashboard</Link>
            <Link to="/biblioteca" className="navbar-link">Biblioteca</Link>
            <Link to="/crear-recorrido" className="navbar-link">Nuevo Recorrido</Link>
            {usuario.es_admin && (
              <Link to="/admin" className="navbar-link admin-link">Admin</Link>
            )}
            <Link to="/perfil" className="navbar-link">Perfil</Link>
            <span className="navbar-user">{usuario.nombre}</span>
            <button onClick={handleLogout} className="btn btn-danger btn-sm">Salir</button>
          </div>
        ) : (
          <div className="navbar-menu">
            <Link to="/login" className="navbar-link">Iniciar Sesión</Link>
            <Link to="/registro" className="btn btn-primary btn-sm">Registrarse</Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

